<template>
	<div class="pt-4 flex no-bottom-margin space-x-4">
		<div>
			<BaseSelect :filter-only="true" :options="filterOptions" v-model="filter" label="Filter" class="w-56" @input="directSearch" />
		</div>
		<div class="flex flex-wrap w-full">
			<BaseInput :filter-only="true" v-model="searchValue" :label="$t('search')" class="flex-grow" @input="search" mask="UUUUUUUUUUUUUUUUUUUUUU" />
		</div>
		<div>
			<BaseButton @click="search" class="mt-8 searchline-button btn-blue w-40">
				{{ $t('search_go') }}
			</BaseButton>
		</div>
	</div>
</template>

<script>
import BaseInput from '@/components/forms/inputs/BaseInput';
import BaseButton from '@/components/forms/buttons/BaseButton';
import BaseSelect from '@/components/forms/inputs/BaseSelect.vue';
export default {
	name: 'RentalCarSearchbar',
	components: { BaseSelect, BaseButton, BaseInput },
	data() {
		return {
			searchValue: null,
			repairShop: null,
			model: null,
			manufacturer: null,
			license_plate: null,
			filterOptions: [
				{
					display: this.$t('active'),
					value: 'enabled',
				},
				{
					display: this.$t('disabled'),
					value: 'disabled',
				},
				{
					display: this.$t('all'),
					value: 'all',
				},
			],
			filter: {
				display: this.$t('active'),
				value: 'enabled',
			},
		};
	},
	methods: {
		search() {
			this.$emit('search', this.getData());
		},
		directSearch() {
			this.$emit('directSearch', this.getData());
		},
		getData() {
			this.searchValue = this.searchValue?.trim();

			return {
				repairShop: this.searchValue,
				model: this.searchValue,
				manufacturer: this.searchValue,
				license_plate: this.searchValue,
				company: this.$store.getters.getAuthenticatedUserGroupLevel === 1 ? this.searchValue : null,
				filter: this.filter,
			};
		},
	},
};
</script>

<style scoped>
.no-bottom-margin .form-group {
	margin-bottom: 0;
}
.searchline-multiselect .multiselect,
.searchline-multiselect .multiselect .multiselect__tags,
.searchline-datepicker input,
.searchline-button {
	height: 43px;
}
</style>
